import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Album.css';
import { albumDetailsMap } from './AlbumConstants';

const Album = () => {
  const { albumName } = useParams();
  const [album, setAlbum] = useState({});
  const [photos, setPhotos] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImg, setModalImg] = useState(null);

  useEffect(() => {
    if (!albumName) return;
    const foundAlbum = albumDetailsMap[albumName] || null;
    setAlbum(foundAlbum);
    setPhotos(foundAlbum && foundAlbum.photoNames ? foundAlbum.photoNames : []);
  }, [albumName]);

  if (!album || !album.name) {
    return (
      <div className="album-container">
        <h1>Album Not Found</h1>
      </div>
    );
  }
  if (photos.length === 0) {
    return (
      <div className="album-container">
        <h1>{album.name}</h1>
        <div>No photos available for this album.</div>
      </div>
    );
  }
  return (
    <div className="album-container">
      <h1>{album.name}</h1>
      <div className="album-photos">
        {photos.map((filename, idx) => (
          <img
            key={idx}
            src={`/Assets/Photos/${encodeURIComponent(
              album.folder
            )}/${filename}`}
            alt={filename}
            className="album-photo"
            onClick={() => {
              setModalImg(
                `/Assets/Photos/${encodeURIComponent(album.folder)}/${filename}`
              );
              setModalOpen(true);
            }}
            style={{ cursor: 'pointer' }}
          />
        ))}
      </div>
      {modalOpen && (
        <div className="album-modal" onClick={() => setModalOpen(false)}>
          <img src={modalImg} alt="Full Size" className="album-modal-img" />
        </div>
      )}
    </div>
  );
};

export default Album;
